import { useCallback, useLayoutEffect, useRef } from 'react';

const PINNED_TO_BOTTOM_SLACK_PX = 80;

const scrollToBottom = (node: HTMLDivElement, behavior: ScrollBehavior) => {
  if (typeof node.scrollTo === 'function') {
    node.scrollTo({ top: node.scrollHeight, behavior });
    return;
  }
  node.scrollTop = node.scrollHeight;
};

// Follows the conversation like a chat app: sticks to the bottom unless the reader scrolled up.
export const useAssistantAutoScroll = (opened: boolean, updateKey: string) => {
  const messagesRef = useRef<HTMLDivElement | null>(null);
  const pinnedRef = useRef(true);
  const justOpenedRef = useRef(true);

  useLayoutEffect(() => {
    if (!opened) return;
    pinnedRef.current = true;
    justOpenedRef.current = true;
  }, [opened]);

  const handleMessagesScroll = useCallback(() => {
    const node = messagesRef.current;
    if (!node) return;
    const distanceFromBottom = node.scrollHeight - node.scrollTop - node.clientHeight;
    pinnedRef.current = distanceFromBottom <= PINNED_TO_BOTTOM_SLACK_PX;
  }, []);

  useLayoutEffect(() => {
    const node = messagesRef.current;
    if (!opened || !node || !pinnedRef.current) return;
    scrollToBottom(node, justOpenedRef.current ? 'auto' : 'smooth');
    justOpenedRef.current = false;
  }, [opened, updateKey]);

  return { messagesRef, handleMessagesScroll };
};
